var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWww = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1527_5202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.71631 17.7067C4.63062 19.2903 5.94574 20.6053 7.52944 21.5195C9.11315 22.4336 10.9096 22.9147 12.7382 22.9144C14.5669 22.9147 16.3633 22.4336 17.947 21.5195C19.5307 20.6053 20.8459 19.2903 21.7602 17.7067M3.71631 7.29114C4.63062 5.70751 5.94574 4.39251 7.52944 3.47834C9.11315 2.56417 10.9096 2.08305 12.7382 2.08337C14.5669 2.08305 16.3633 2.56417 17.947 3.47834C19.5307 4.39251 20.8459 5.70751 21.7602 7.29114",
    stroke: "#001537",
    strokeWidth: 1.56233,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7799 22.8624C13.7799 22.8624 15.2464 20.9324 16.1702 17.7067M13.7799 2.1355C13.7799 2.1355 15.2464 4.06445 16.1702 7.29118M11.6968 22.8624C11.6968 22.8624 10.2303 20.9334 9.30641 17.7067M11.6968 2.1355C11.6968 2.1355 10.2303 4.06445 9.30641 7.29118M9.61367 10.4158L11.176 15.6236L12.7383 10.4158L14.3007 15.6236L15.863 10.4158M1.28125 10.4158L2.84358 15.6236L4.40591 10.4158L5.96824 15.6236L7.53057 10.4158M17.9461 10.4158L19.5084 15.6236L21.0708 10.4158L22.6331 15.6236L24.1954 10.4158",
    stroke: "#001537",
    strokeWidth: 1.56233,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1527_5202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.9973,
    height: 24.9973,
    fill: "white",
    transform: "translate(0.239258 0.000366211)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWww, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/www.308e6527.svg";
export { ForwardRef as ReactComponent };